export default __webpack_public_path__ + "static/media/zefat.73d2b715.jpeg";